var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm12":""}},[_c('h1',[_vm._v("Welcome")]),_c('pre',[_vm._v("        "+_vm._s(_vm.user)+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }